import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { DialogComponent } from './dialog.component';
import { LabelsService, ILabel } from '../../providers/labels/labels.service';
import { isFunction } from 'lodash';

@Injectable()
export class DialogService {
  dialog: MatDialog;
  labelsService: LabelsService;
  // eslint-disable-next-line
  data: any;

  constructor(dialog: MatDialog, labelsService: LabelsService) {
    this.dialog = dialog;
    this.labelsService = labelsService;
  }

  // eslint-disable-next-line
  showDialog(dialogType, parent, params) {
    if (params) {
      const labelObj = this.labelsService.getLabel(params.id) as ILabel;

      this.data = {
        reverseBtn: labelObj.reverseBtn ? true : false,
        title: params.alternateTitle ? params.alternateTitle : labelObj.label + '?',
        msgContent: params.alternateMsg ? params.alternateMsg : labelObj.msgText,
        subMessage: params?.subMessage,
        okText: labelObj.okText,
        cancelText: labelObj.cancelText,
        dialogPrams: params
      };
    }
    this.data.type = dialogType;
    const dialogRef = this.dialog.open(DialogComponent, {
      panelClass: 'no-padding-dialog',
      disableClose: this.data.type === 'confirm' ? true : false,
      data: this.data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.doTheActionAndHide();
      } else {
        if (isFunction(this.data.dialogPrams.cancelCallback)) {
          this.data.dialogPrams.cancelCallback(this.data.dialogPrams.callBackService);
        }
      }
    });
  }
  // eslint-disable-next-line
  showInfo(dialogType, parent, info, title, copyClipboard?: any) {
    this.data = {
      type: dialogType,
      title,
      okText: 'OK',
      msgContent: info,
      copyClipboard
    };

    const dialogRef = this.dialog.open(DialogComponent, {
      panelClass: 'no-padding-dialog',
      data: this.data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.doTheActionAndHide();
      }
    });
  }
  // eslint-disable-next-line
  closeAll() {
    this.dialog.closeAll();
  }
  // eslint-disable-next-line
  doTheActionAndHide() {
    if (this.data.type !== 'information' && isFunction(this.data.dialogPrams.callBackFuntion)) {
      if (this.data.dialogPrams.callBackFnParams !== null) {
        this.data.dialogPrams.callBackFuntion(
          this.data.dialogPrams.callBackService,
          this.data.dialogPrams.callBackFnParams
        );
      } else {
        this.data.dialogPrams.callBackFuntion(this.data.dialogPrams.callBackService, null);
      }
    }
  }
}
